export default __webpack_public_path__ + "static/media/security.81109334.svg";